import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ic_bg_top.png'
import _imports_1 from '../assets/open_gate.png'
import _imports_2 from '../assets/close_gate.png'
import _imports_3 from '../assets/capture.png'


const _withScopeId = n => (_pushScopeId("data-v-305396a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "col-box",
  style: {"height":"100vh"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { style: {"position":"fixed","left":"0","top":"0","right":"0","height":"100%","z-index":"100"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_5 = { class: "player-shell" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_7 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","padding":"0 20px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"25px","height":"25px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开闸", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"25px","height":"25px"}
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "落闸", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"width":"25px","height":"25px"}
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "抓拍", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayerFull = _resolveComponent("PlayerFull")!
  const _component_CameraLiveList = _resolveComponent("CameraLiveList")!
  const _component_CameraImageList = _resolveComponent("CameraImageList")!
  const _component_NavTabs = _resolveComponent("NavTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PlayerFull, { ref: "liveStream" }, null, 512)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "col-box-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openGate()))
        }, _hoisted_10),
        _createElementVNode("div", {
          class: "col-box-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeGate()))
        }, _hoisted_13),
        _createElementVNode("div", {
          class: "col-box-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.capturePhone()))
        }, _hoisted_16)
      ]),
      _hoisted_17,
      _createElementVNode("div", null, [
        _createVNode(_component_NavTabs, { onBindTabItemClickEvent: _ctx.onClickTabItemEvent }, {
          default: _withCtx(() => [
            (_ctx.activeTabIndex == 0)
              ? (_openBlock(), _createBlock(_component_CameraLiveList, {
                  key: 0,
                  roadId: _ctx.roadId,
                  videoId: _ctx.curVideoId,
                  onBindSelectVideoItemEvent: _ctx.onSelectVideoItemEvent
                }, null, 8, ["roadId", "videoId", "onBindSelectVideoItemEvent"]))
              : _createCommentVNode("", true),
            (_ctx.activeTabIndex == 1)
              ? (_openBlock(), _createBlock(_component_CameraImageList, {
                  key: 1,
                  parkingId: _ctx.parkingId,
                  roadId: _ctx.roadId
                }, null, 8, ["parkingId", "roadId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onBindTabItemClickEvent"])
      ])
    ])
  ]))
}